"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("../helpers/parse");
var parse_2 = require("../helpers/parse");
var tabNav_1 = require("./tabNav");
var formValidator_1 = require("./formValidator");
var formsCollection_1 = require("./formsCollection");
var profanityFilter_1 = require("../book/profanityFilter");
/**
 * Keep track of index of selected option.
 *
 * The primary use case for this is to remember the option chosen by the user, independent of the
 * current value that may change due to reevaluation of options.
 */
var Form = /** @class */ (function () {
    function Form() {
        this.selected = {};
    }
    Form.prototype.select = function (group, id, index) {
        this.selected[group] = this.selected[group] || {};
        this.selected[group][id] = index;
    };
    Form.prototype.get = function (group, id) {
        if (!this.selected[group] || !this.selected[group][id]) {
            return;
        }
        return this.selected[group][id];
    };
    return Form;
}());
/**
 * Renders each form of a group.
 */
function FormGroupDirective(config, book, formsCollection) {
    return {
        templateUrl: config.params.base + 'templates/form/form-group.html',
        scope: true,
        bindToController: {
            'id': '=group'
        },
        controller: /** @class */ (function () {
            function FormGroupController() {
            }
            FormGroupController.prototype.getForms = function (column) {
                column = column || 1;
                formsCollection.evaluate(book);
                return formsCollection.getGroup(this.id, column);
            };
            FormGroupController.prototype.getColumns = function (id) {
                return formsCollection.getColumns(id);
            };
            return FormGroupController;
        }()),
        controllerAs: 'formGroup'
    };
}
/**
 * Renders a form and its options.
 */
function FormDirective(config) {
    return {
        templateUrl: config.params.base + 'templates/form/form.html',
        scope: true,
        bindToController: {
            element: '=form' // Form element to render options of
        },
        controller: FormController,
        controllerAs: 'form'
    };
}
function FormTitleDirective($compile, book, textResolver, testFeatures) {
    'ngInject';
    return {
        restrict: 'AE',
        scope: {
            value: '='
        },
        link: function (scope, elem) {
            Object.assign(scope, book);
            scope.resolve = textResolver.resolve.bind(textResolver);
            scope.hasFeature = testFeatures.hasFeature.bind(testFeatures);
            elem.append($compile('<span>' + scope.value + '</span>')(scope));
        }
    };
}
exports.FormTitleDirective = FormTitleDirective;
function InputLabelDirective($compile, book, textResolver, testFeatures) {
    'ngInject';
    return {
        restrict: 'AE',
        scope: {
            label: '='
        },
        link: function (scope, elem) {
            Object.assign(scope, book);
            scope.resolve = textResolver.resolve.bind(textResolver);
            scope.hasFeature = testFeatures.hasFeature.bind(testFeatures);
            elem.append($compile('<span>' + scope.label + '</span>')(scope));
        }
    };
}
exports.InputLabelDirective = InputLabelDirective;
/**
 * Exposes form element properties and its options.
 *
 * Keeps track of chosen (or entered) value.
 */
var FormController = /** @class */ (function () {
    function FormController($scope, $element, $timeout, book, tabNav, preview) {
        var _this = this;
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.book = book;
        this.tabNav = tabNav;
        this.preview = preview;
        this.click = 0;
        // Delegate to form element
        this.id = this.element.id;
        this.type = this.element.type;
        this.label = this.element.label;
        this.title = this.element.title;
        this.group = this.element.group;
        this.column = this.element.column || 1;
        this.validation = this.element.validation;
        this.singlecol = this.element.singlecol;
        this.default = this.element.default;
        this.reset = this.element.reset;
        this.options = this.element.options;
        this.checkAllOptions = this.element.checkAllOptions;
        this.condition = this.element.condition;
        this.hidden = this.element.hidden;
        this.previewPage = this.element.previewPage;
        this.zoom = this.element.zoom;
        this.hasFocus = false;
        this.profane = false;
        $scope.$watch(function () {
            return typeof _this.value === 'object' ? JSON.stringify(_this.value) : _this.value;
        }, this.updateTabValidity.bind(this));
        $scope.$watch(function () {
            var _a = _this.id.split('.'), prefix = _a[0], id = _a[1];
            return {
                options: _this.getOptions().length,
                value: book[prefix][id]
            };
        }, function (newVal, oldVal) {
            _this.showProfanityValidation(false);
            var _a = _this.id.split('.'), prefix = _a[0], id = _a[1];
            // Force index to be smaller than options.length:
            if (['image', 'radio'].includes(_this.type) && newVal.options > 0 && newVal.options - 1 < _this.value) {
                _this.value = newVal.options - 1;
                _this.book.update(prefix, id, _this.value);
            }
            book.resolve();
            _this.updateTabValidity();
        }, true);
        if (profanityFilter_1.textInputs.includes(this.type)) {
            var tab = this.findTab();
            tab.formsWithProfanityFilter.push(this);
        }
        if (this.type === 'upload-switch') {
            this.tabNav.tabs.formsWithHiddenOptions.push(this);
        }
    }
    FormController.prototype.isDisabled = function () {
        if (!this.condition) {
            return false;
        }
        return !parse_2.evaluateCondition(this.condition, this.book);
    };
    FormController.prototype.isHidden = function () {
        if (!this.hidden) {
            return false;
        }
        return parse_2.evaluateCondition(this.hidden, this.book);
    };
    FormController.prototype.isTabInvisible = function () {
        var tab = this.findTab();
        return !tab.isVisible;
    };
    FormController.prototype.getOptions = function () {
        var options = parse_1.filterOptions(this.options);
        return options;
    };
    FormController.prototype.hasValidation = function (type) {
        // Is the form active? Do not validate disabled forms.
        if (this.type === 'radio-input') {
            var option = this.options[this.value];
            if (!option.custom || this.isDisabled()) {
                return false;
            }
        }
        else if (this.isDisabled()) {
            return false;
        }
        // Check for type of validation
        return this.validation === type;
    };
    FormController.prototype.isSingleCol = function () {
        return this.singlecol === undefined ? true : this.singlecol;
    };
    FormController.prototype.showInvalidFormOption = function () {
        var _this = this;
        var _a = this.id.split('.'), prefix = _a[0], id = _a[1];
        var index = this.options.findIndex(function (option) {
            var value = _this.book[prefix][option.value];
            return !value;
        });
        if (index >= 0) {
            this.setOption(index);
        }
        this.hideValidation(false);
    };
    FormController.prototype.hideValidation = function (hide) {
        if (hide === void 0) { hide = true; }
        var tab = this.findTab();
        if (tab) {
            // Wait for digest cycle to complete before retrieving validity from form
            this.$timeout(function () {
                tab.enableValidation(!hide);
                if (tab instanceof tabNav_1.SubTab) {
                    tab.parent.enableValidation(!hide);
                }
            });
        }
    };
    FormController.prototype.showProfanityValidation = function (show) {
        if (show === void 0) { show = true; }
        this.profane = !!show;
    };
    // Sync form and tab validity
    FormController.prototype.updateTabValidity = function () {
        var _this = this;
        var tab = this.findTab();
        var isValid = function (form, type) {
            return !(type in _this.$scope[form].$error);
        };
        if (tab) {
            // Wait for digest cycle to complete before retrieving validity from form
            this.$timeout(function () {
                tab.setValidity('pattern', isValid('$formGroupController', 'pattern'));
                tab.setValidity('required', isValid('$formGroupController', 'required'));
                if (tab instanceof tabNav_1.SubTab) {
                    tab.parent.setValidity('pattern', isValid('$formTabController', 'pattern'));
                    tab.parent.setValidity('required', isValid('$formTabController', 'required'));
                }
            });
        }
    };
    FormController.prototype.setNextOption = function () {
        this.setOptionInDirection('next');
    };
    FormController.prototype.setPrevOption = function () {
        this.setOptionInDirection('prev');
    };
    FormController.prototype.setActive = function () {
        if (!this.isDisabled()) {
            this.preview.setActiveForm(this);
            this.zoomPage();
        }
    };
    FormController.prototype.setPreviewPage = function (id) {
        if (isNaN(id)) {
            return;
        }
        this.preview.setActive(id);
    };
    FormController.prototype.zoomPage = function (zoomIn) {
        var option = this.options[this.value];
        var zoom = this.zoom || option && option.previewZoom;
        var page = zoom && typeof zoom.page === 'number' ? zoom.page : this.previewPage;
        zoomIn = zoomIn !== false;
        if (zoom && zoomIn) {
            this.preview.zoomPage(page, zoomIn, zoom.scale, zoom.x, zoom.y);
        }
        else if (zoom) {
            this.preview.zoomPage(page, zoomIn);
        }
    };
    FormController.prototype.setOption = function (index) {
        var _a = this.id.split('.'), prefix = _a[0], id = _a[1];
        this.value = index;
        this.book.update(prefix, id, this.value);
        this.zoomPage();
        // Hide (not disable) validations when
        // stepping through upload-switch
        if (this.type === 'upload-switch') {
            this.hideValidation();
        }
    };
    FormController.prototype.setOptionInDirection = function (direction) {
        var increment = (direction === 'next') ? +1 : -1;
        var index = this.value + this.getOptions().length + increment;
        index %= this.getOptions().length;
        this.setOption(index);
    };
    FormController.prototype.findTab = function () {
        var _a = this.element.group.split('.'), main = _a[0], sub = _a[1];
        return this.tabNav.tabs.findTab(sub ? sub : main, sub ? main : sub);
    };
    FormController.prototype.setValidity = function (type, valid) {
        this.$scope.$formController.$setValidity(type, valid);
        // Avoid error being reset by marking overall form as dirty
        if (valid) {
            this.$scope.$formController.$setDirty();
        }
        this.updateTabValidity();
    };
    FormController.prototype.onClick = function () {
        this.setActive();
    };
    FormController.prototype.onMouseEnter = function () {
        this.zoomPage();
    };
    FormController.prototype.onMouseLeave = function () {
        if (!this.hasFocus) {
            this.zoomPage(false);
        }
    };
    FormController.prototype.onFocus = function () {
        this.hasFocus = true;
        this.setActive();
    };
    FormController.prototype.onBlur = function () {
        this.hasFocus = false;
        this.zoomPage(false);
    };
    FormController.prototype.onKeyUp = function (e) {
        if (13 === e.keyCode) {
            this.$element.find('input').blur();
        }
    };
    return FormController;
}());
exports.FormController = FormController;
/**
 * Base class of form option controllers (e.g. `radio`).
 */
var FormOptionController = /** @class */ (function () {
    function FormOptionController($scope, book) {
        this.$scope = $scope;
        this.book = book;
        this.form = $scope.form;
        this.prefix = $scope.form.id.split('.')[0];
        this.id = $scope.form.id.split('.')[1];
        this.value = $scope.option.value;
        this.label = $scope.option.label;
        this.maxCols = $scope.option.maxCols;
        this.maxRows = $scope.option.maxRows;
        this.previewPage = $scope.option.previewPage;
        this.previewZoom = $scope.option.previewZoom;
        this.dialogOptions = $scope.option.dialogOptions;
        this.counterOptions = $scope.option.counterOptions;
        this.gmPlacesOptions = $scope.option.gmPlacesOptions;
        this.gmStaticOptions = $scope.option.gmStaticOptions;
    }
    FormOptionController.prototype.setSingleCol = function (single) {
        if (this.form.singlecol === undefined) {
            this.form.singlecol = single;
        }
    };
    FormOptionController.prototype.onChange = function (index) {
        this.book.set(this.prefix, this.id, this.form.value);
    };
    return FormOptionController;
}());
exports.FormOptionController = FormOptionController;
var text_1 = require("./options/text");
var textarea_1 = require("./options/textarea");
var textarea_lf_1 = require("./options/textarea-lf");
var letters_1 = require("./options/letters");
var glyphs_1 = require("./options/glyphs");
var number_1 = require("./options/number");
var tel_1 = require("./options/tel");
var autotext_1 = require("./options/autotext");
var counter_1 = require("./options/counter");
var date_1 = require("./options/date");
var radio_1 = require("./options/radio");
var radio_input_1 = require("./options/radio-input");
var checkbox_1 = require("./options/checkbox");
var check_all_1 = require("./options/check-all");
var imageSwitch_1 = require("./options/imageSwitch");
var colorSwitch_1 = require("./options/colorSwitch");
var uploadSwitch_1 = require("./options/uploadSwitch");
var upload_1 = require("./options/upload");
var tab_1 = require("./options/tab");
var gm_places_1 = require("./options/gm-places");
var gm_static_1 = require("./options/gm-static");
var upload_thumb_1 = require("./options/upload-thumb");
exports.default = angular.module('pb.form', [])
    .service('form', Form)
    .service('formValidator', formValidator_1.FormValidator)
    .service('formsCollection', formsCollection_1.FormsCollection)
    .directive('pbFormGroup', FormGroupDirective)
    .directive('pbForm', FormDirective)
    .directive('pbTitle', FormTitleDirective)
    .directive('pbLabel', InputLabelDirective)
    .directive('pbText', text_1.TextDirective)
    .directive('pbLetters', letters_1.LettersDirective)
    .directive('pbGlyphs', glyphs_1.GlyphsDirective)
    .directive('pbTextarea', textarea_1.TextareaDirective)
    .directive('pbTextareaLf', textarea_lf_1.TextareaLfDirective)
    .directive('pbAutotext', autotext_1.AutotextDirective)
    .directive('pbCounter', counter_1.CounterDirective)
    .directive('pbNumber', number_1.NumberDirective)
    .directive('pbTel', tel_1.TelDirective)
    .directive('pbDate', date_1.DateDirective)
    .directive('pbRadio', radio_1.RadioDirective)
    .directive('pbRadioInput', radio_input_1.RadioInputDirective)
    .directive('pbCheckbox', checkbox_1.CheckboxDirective)
    .directive('pbCheckAll', check_all_1.CheckAllDirective)
    .directive('pbImageSwitch', imageSwitch_1.ImageSwitchDirective)
    .directive('pbColorSwitch', colorSwitch_1.ColorSwitchDirective)
    .directive('pbUploadSwitch', uploadSwitch_1.UploadSwitchDirective)
    .directive('pbUpload', upload_1.UploadDirective)
    .directive('pbGmPlaces', gm_places_1.GmPlacesDirective)
    .directive('pbGmStatic', gm_static_1.GmStaticDirective)
    .directive('pbTab', tab_1.TabDirective)
    .directive('pbUploadThumb', upload_thumb_1.UploadThumbDirective);
